import type { BundleItem } from '../rewards/types';

export type FullPageDialogs =
  | 'store'
  | 'redeem'
  | 'account'
  | 'rewards'
  | 'prevent_purchase'
  | 'loyalty_program'
  | 'new_tier_congrats'
  | 'tier_monthly_bonus'
  | 'tier_birthday_gift'
  | 'bingo';

export type FullPageDialogsOptions = {
  isOpenFundsHistory?: boolean;
  from?: string;
  onClose?: VoidFunction;
  openToDynastyBenefits?: boolean;
};

export type Slide = FullPageDialogs | 'home';

export const enum EnumOpenDialog {
  isOpenChallengeDialog = 'isOpenChallengeDialog',
  isOpenKycDialog = 'isOpenKycDialog',
  isOpenOrderSummaryDialog = 'isOpenOrderSummaryDialog',
  isOpenPersonalDetailsDialog = 'isOpenPersonalDetailsDialog',
  isOpenCardDetailsDialog = 'isOpenCardDetailsDialog',
  isOpenTransactionFailedDialog = 'isOpenTransactionFailedDialog',
  isOpenPurchaseFailedDialog = 'isOpenPurchaseFailedDialog',
  isOpenPurchaseSuccessDialog = 'isOpenPurchaseSuccessDialog',
  isOpenPurchaseSuccessDialogV2 = 'isOpenPurchaseSuccessDialogV2',
  isOpenKYCFailedDialog = 'isOpenKYCFailedDialog',
  isOpenInviteFriendsBonusDialogNew = 'isOpenInviteFriendsBonusDialogNew',
  isOpenInviteFriendsNew = 'isOpenInviteFriendsNew',
  isOpenTransactionFailedDueToAddressDialog = 'isOpenTransactionFailedDueToAddressDialog',
  isOpenThirdPartyIframeDialog = 'isOpenThirdPartyIframeDialog',
  isOpenPurchaseLimitIncreaseDialog = 'isOpenPurchaseLimitIncreaseDialog',
  isOpenPurchaseLimitGiftDialog = 'isOpenPurchaseLimitGiftDialog',
  isOpenTransactionWaitingDialog = 'isOpenTransactionWaitingDialog',
  isOpenTokenExCvvOnlyDialog = 'isOpenTokenExCvvOnlyDialog',
  isOpenTournamentDialog = 'isOpenTournamentDialog',
  isOpenQuestDialog = 'isOpenQuestDialog',
  isOpenDailyMissionDialog = 'isOpenDailyMissionDialog',
  isOpenEventTriggerDialog = 'isOpenEventTriggerDialog',
  isOpenTermsOfService = 'isOpenTermsOfService',
  isOpenCoinBackDialog = 'isOpenCoinBackDialog',
  isOpenCoinBackBoosterDialog = 'isOpenCoinBackBoosterDialog',
  isOpenRedemptionApprovalDialog = 'isOpenRedemptionApprovalDialog',
  isOpenMinigamesDialog = 'isOpenMinigamesDialog',
  isOpenDailyMissionGrandPrizeGiftDialog = 'isOpenDailyMissionGrandPrizeGiftDialog',
  isOpenMissionsDialog = 'isOpenMissionsDialog',
  isOpenRedemptionActivationDialog = 'isOpenRedemptionActivationDialog',
  isOpenMetagamesDialog = 'isOpenMetagamesDialog',
  isOpenMonetizationEventsDialog = 'isOpenMonetizationEventsDialog',
  isOpenGameUiDialog = 'isOpenGameUiDialog',
  isOpenRedemptionExpiredDialog = 'isOpenRedemptionExpiredDialog',
  isOpenMarketingConsentDialog = 'isOpenMarketingConsentDialog',
  isOpenWelcomeBonusDialog = 'isOpenWelcomeBonusDialog',
  isOpenPromoCodeDialog = 'isOpenPromoCodeDialog',
  isOpenCancelSubscriptionDialog = 'isOpenCancelSubscriptionDialog',
  isOpenRedeemDialog = 'isOpenRedeemDialog',
  isOpenBingoEventsCalendarDialog = 'isOpenBingoEventsCalendarDialog',
  isOpenCashRedemptionHistoryDialog = 'isOpenRedemptionHistoryDialog',
  isOpenCrownPrimeIntroDialog = 'isOpenCrownPrimeIntroDialog',
  isOpenBingoPayTableDialog = 'isOpenBingoPayTableDialog',
  isOpenMyCardsDialog = 'isOpenMyCardsDialog',
  isOpenBingoResultsDialog = 'isOpenBingoResultsDialog',
  isOpenEditProfileDialogNew = 'isOpenEditProfileDialogNew',
  isOpenFundsHistoryDialogNew = 'isOpenFundsHistoryDialogNew',
  isOpenDynastyDialog = 'isOpenDynastyDialog',
  isOpenGameModeSelectionDialog = 'isOpenGameModeSelectionDialog',
  isOpenLocationRestrictedDialog = 'isOpenLocationRestrictedDialog',
  isOpenSlotPopupDialog = 'isOpenSlotPopupDialog',
  isOpenCrownJackpotWinDialog = 'isOpenCrownJackpotWinDialog',
  isOpenSlotBattleDialog = 'isOpenSlotBattleDialog',
}

export interface IOpenDialog {
  dialog: EnumOpenDialog | null;
  options?: {
    [key: string]: Record<string, unknown> | string | number | boolean | null | undefined | VoidFunction;
  };
}

export type AnimationProps = {
  fadeInDurationMs?: number;
  transitionDurationMs?: number;
};

export type XYPoint = { x: number; y: number };

export type LandingPos = {
  gcLandingPoint: XYPoint;
  scLandingPoint: XYPoint;
};

export type CoinsLandingPos = {
  gcLandingPoint: XYPoint;
  scLandingPoint: XYPoint;
};

export type ClaimableReward = {
  scCoin: number;
  gcCoin: number;
  bundleItems: BundleItem[];
};

export type ClaimRewardAnimationState = {
  enable: boolean;
  rewards?: ClaimableReward[];
  onEnd?: () => void | Promise<void>;
  refetchData?: boolean;
  enableSounds?: boolean;
  startMiniGames?: boolean;
  hideOverlay?: boolean;
};

export type LiveBannerData = {
  /**
   * Unique ID for the specific message with retrigger same message consideration (new retrigger - new key).
   * If not given - message will be shown always until deactivated by admin.
   */
  bannerKey: null | string;
  /** How many lobby enters should pass before banner removed. */
  appearanceLimit: number;
  showCloseButton: boolean;
  showLogo: boolean;
  bannerMessage: null | string;
  activatedAt: Date;
  expiresAt: Date | null;
};
